export default __webpack_public_path__ + "static/media/bell_negative.d5f4d5d3.svg";